"use client";

import { useCallback } from "react";
import { ReactionWidget } from "./reaction-widget";

/**
 * Banc du bouton de réaction, en dev seulement : `/studio?widget=hearts`. Une
 * salle simulée envoie des cœurs par rafales, et ce qu'on tape monte sans
 * partir nulle part.
 */
export function ReactionWidgetDemo() {
  const hearts = useCallback((listener: (hearts: number, total: number) => void) => {
    let total = 0;

    const timer = setInterval(() => {
      const burst = Math.random() < 0.4 ? 0 : 1 + Math.floor(Math.random() * 6);
      total += burst;

      if (burst > 0) {
        listener(burst, total);
      }
    }, 700);

    return () => clearInterval(timer);
  }, []);

  return <ReactionWidget onTap={() => undefined} hearts={hearts} />;
}
